import React from 'react';

const CasestudyContentPage = () => {
    return (
        <div className="d-flex justify-content-center align-items-center min-vh-100">
            <div className="container">
                <div className="col-xs-12 entry-content col-md-12" id="article-content">
                    {/* Author Info */}
                    {/* <div className="authors-info">
                        By <a href="#author-bio" title="Click here for more info on the author">Mike Rouman</a>
                    </div> */}

                    {/* Main Article Content */}
                    <p style={{ fontSize: '28px', color: "#000" }}>
                        <strong>Automaker shows how streamlined assembly line design helps to connect disparate systems <span style={{ color: "rgb(5 134 155)" }}> and drive cost efficiency in manufacturing </span></strong>
                    </p>

                    <p style={{ color: "#000", textAlign: 'justify' }}>
                        The automotive industry, among others, suffers from disparate IT systems that make harnessing the value of data difficult. Connecting insight across products, processes, and people is an ongoing challenge. Even as digital manufacturing matures, integrating various digital threads is still elusive for many manufacturers.
                    </p>

                    <p style={{ color: "#000", textAlign: 'justify' }}>
                        Earlier this year, Jim White, a member of the Powertrain Manufacturing Engineering Digital Innovation Team at Ford Motor Company, presented their application of Line Designer in the Envision NX™ software portfolio at{' '}
                        {/* <span style={{ textDecoration: 'underline' }}>
                            <a
                                href="https://events.sw.siemens.com/en-US/realizelive/experiences/digital-manufacturing-conference/"
                                target="_blank"
                                rel="noopener"
                            >
                                Realize LIVE
                            </a>
                        </span> */}
                        , Envision’ worldwide user conference. This blog summarizes that presentation and shows how automating factory layout authoring is unifying Ford’s systems and driving cost efficiency.
                    </p><br></br>

                    <p style={{ fontSize: '24px', color: "rgb(5 134 155)" }}>
                        <strong>The project</strong>
                    </p><br></br>

                    <p style={{ color: "#000", textAlign: 'justify' }}>
                        Ford Motor Company is a leading global automotive OEM with 186,000 employees worldwide (2020). Jim White is a powertrain manufacturing engineer and has been with Ford for over 25 years. He is currently part of the Powertrain Manufacturing Engineering Digital Innovation team and is responsible for developing and delivering new technical solutions and systems to make the job of engineering and delivering a powertrain manufacturing facility quicker, easier, and cheaper.
                    </p>

                    {/* Image */}
                    <div className="wp-block-image">
                        <figure className="aligncenter size-large">
                            <img
                                decoding="async"
                                width="1024"
                                height="576"
                                src="https://blogs.sw.siemens.com/wp-content/uploads/sites/7/2021/11/Ford-EPRIME-Summary-1024x576.png"
                                alt="Ford E:PriME Project"
                                className="wp-image-5500"
                            />
                            {/* <figcaption className="wp-element-caption">Ford Motor Company is the lead member of the E:PriME project.</figcaption> */}
                        </figure>
                    </div>

                    <p style={{ color: "#000", textAlign: 'justify' }}>
                        The work presented by Jim was made possible through the E:PriME project. E:PriME is a UK government-funded project with the aim of developing the UK industry’s skills in both electrified powertrain manufacturing techniques and digital tools that can be used to support the manufacturing engineering process. E:PriME consists of a consortium of 7 diverse companies, of which Ford Motor Company is the lead member.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default CasestudyContentPage;
